export default "__VITE_ASSET__DNF62YUY__"